import { useIntl } from 'react-intl'

import BadgeCinestar from '../../../../../../../components/Badges/BadgeCinestar/BadgeCinestar'
import Typography from '../../../../../../../components/Typography/Typography'
import { formatRelativeDay, formatTime } from '../../../../../../../global/helpers'

import './MovieOrderInfo.scss'

//TODO add badges and properties ... P, dolby atmos, ...
const MovieOrderInfo = ({ event }) => {
    const intl = useIntl()
    const startTime = formatTime(event.start)
    const relativeDay = formatRelativeDay(event.start)

    return (
        <div className={'movie-order-info position-relative d-flex justify-content-between gap-3'}>
            <div className={'movie-image position-absolute top-0 bottom-0 start-0 end-0 w-100'}>
                <img
                    src={event.imageUrl}
                    alt={event.title_group ?? event.title}
                    loading={'lazy'}
                    className={'default'}
                />
            </div>

            <div className={'d-flex position-relative align-items-center gap-4'}>
                <img
                    src={event.posterUrl}
                    alt={event.title_group ?? event.title}
                    loading={'lazy'}
                    className={'movie-poster h-auto'}
                />

                <div className={'d-flex flex-column gap-2'}>
                    <BadgeCinestar type={'filled'} className={'me-auto text-uppercase'}>
                        {intl.formatMessage({ id: 'userProfile.ticketsAndReserv.tickets' })}
                    </BadgeCinestar>
                    <Typography variant={'h2'}>{`${event.title_group ?? event.title}`}</Typography>

                    <div className={'d-flex flex-wrap gap-2'}>
                        <BadgeCinestar type={'outline'}>{`${event.duration_minutes} MIN`}</BadgeCinestar>
                        {/* <BadgeCinestar type={'outline'}>P</BadgeCinestar>
                        <Typography variant={'badge'}>DOLBY ATMOS</Typography> */}
                        {event.movieSubtitles && (
                            <Typography variant={'badge'}>
                                {intl.formatMessage({ id: 'hall.hallHeader.subtitles' })}
                            </Typography>
                        )}
                    </div>
                </div>
            </div>

            <div className={'movie-order-info--date position-relative d-flex gap-2'}>
                <Typography variant={'p'}>
                    {relativeDay === 'today' || relativeDay === 'tomorrow'
                        ? intl.formatMessage({ id: `global.days.${relativeDay}` })
                        : relativeDay}
                </Typography>
                <Typography variant={'h2'} className={'text-nowrap'}>
                    {`${startTime}, ${event.venue}`}
                </Typography>
            </div>
        </div>
    )
}

export default MovieOrderInfo
